module.exports = __webpack_public_path__ + "static/4-3f94cccbb8d9dd908600022b599127cb.jpg";